var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.deviceTypeOptions,"disabled":_vm.disabled,"reduce":label => label.code,"label":"label"},model:{value:(_vm.infoId),callback:function ($$v) {_vm.infoId=$$v},expression:"infoId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }